import './smooth-image.scss';
import {Box, useTheme} from '@mui/material';
import {useState} from 'react';
import {isSvg} from '../../utils/functions/validate-uri-svg';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Image container used in our forms.
 */
export function SmoothImage(props: {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  imageWidth?: number;
  imageHeight?: number;
  borderRadius?: string;
  backgroundColor?: string;
  borderWidth?: number;
  borderColor?: string;
}) {
  // Hold State
  const [imageLoaded, setImageLoaded] = useState(false);

  // Get theme
  const theme = useTheme();

  // Default result
  return (
    <Box
      border={typeof props.borderWidth === 'number' ? props.borderWidth : 1}
      borderColor={props.borderColor ? props.borderColor : theme.palette.action.disabled}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: props.borderRadius ? props.borderRadius : 'inherit',
        backgroundColor: props.backgroundColor ? props.backgroundColor : 'inherit',
        overflow: 'hidden',
        backgroundClip: 'padding-box',
        width: '100%',
        maxWidth: props.width ? props.width : 'inherit',
        height: props.height ? props.height : 'inherit',
      }}
    >
      {props.src && props.src.trim() !== '' ? (
        isSvg(props.src) ? (
          <object
            width={props.imageWidth ? `${props.imageWidth}` : undefined}
            height={props.imageHeight ? `${props.imageHeight}` : undefined}
            data={props.src}
            aria-label={props.alt}
            type="image/svg+xml"
            className={`smooth-image smooth-image-svg-object image-${imageLoaded ? 'visible' : 'hidden'}`}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageLoaded(true)}
          ></object>
        ) : (
          <img
            style={{
              width: '100%',
              maxWidth: props.imageWidth ? props.imageWidth : 'inherit',
              height: props.imageHeight ? props.imageHeight : 'inherit',
              objectFit: 'cover',
            }}
            src={props.src}
            alt={props.alt}
            className={`smooth-image image-${imageLoaded ? 'visible' : 'hidden'}`}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageLoaded(true)}
          />
        )
      ) : undefined}
      {props.src && props.src.trim() !== '' && !imageLoaded && (
        <Box className="smooth-preloader">
          <CircularProgress size={20} />
        </Box>
      )}
    </Box>
  );
}
